import { createStore, combineReducers, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import { all } from 'redux-saga/effects';

// Import reducers
import makes, { watchMakeRequest } from './makes';
import feeds, { watchFeedRequest } from './feeds';
import modelsYears from './models-years';
import templates from '../../templates/display/data/templates';

function* rootSaga() {
  yield all([
    watchFeedRequest(),
    watchMakeRequest(),
  ]);
}

const sagaMiddleware = createSagaMiddleware();

const rootReducer = combineReducers({
  makes,
  modelsYears,
  feeds,
  templates,
});

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(sagaMiddleware)),
);

sagaMiddleware.run(rootSaga);

export default store;



// WEBPACK FOOTER //
// ./src/main/data/store.js